import './event-receipt-modal.style.sass';
import template from './event-receipt-modal.tpl.pug';

class EventReceiptModalController {
    /* @ngInject */
    constructor($window) {
        this.$window = $window;
    }

    dismiss() {
        return this.onDismiss();
    }

    attach() {
        return this.onClose({
            data: true
        });
    }

    download() {
        if (!this.imageUrl) {
            return null;
        }

        const anchor = this.$window.document.createElement('a');
        anchor.href = this.imageUrl;
        anchor.download = this.fileName || 'receipt-image';
        anchor.target = '_blank';
        anchor.rel = 'noopener';
        anchor.click();

        return null;
    }
}

export default {
    selector: 'dbAEventReceiptModal',
    template: template(),
    controller: EventReceiptModalController,
    bindings: {
        imageUrl: '<',
        fileName: '<',
        canAttach: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-receipt-modal/event-receipt-modal.cmpt.js